import { Component, Inject, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ModalWindowBaseComponent } from './modal-window-base.component';

import { IModalWindowMessageFormat } from './modal-window.service';
import { MODAL_WINDOW_IMPORTS } from './modal-window.config';

@Component({
  selector: 'modal-window',
  templateUrl: './modal-window.component.html',
  styleUrls: ['./modal-window.component.scss'],
  imports: MODAL_WINDOW_IMPORTS
})
export class ModalWindowComponent extends ModalWindowBaseComponent implements OnInit {
   public override moda_window_ref: MatDialogRef<any> = inject(MatDialogRef);
   public data: IModalWindowMessageFormat = inject(MAT_DIALOG_DATA);
  // ===========================================================================
  // ---------------------------------------------------------------------------
  ngOnInit(): void {
      if ( ! this.data.type ) {
        this.data.type = this.data.icon;
      }
      if ( this.data.type === 'confirm') {
        this.data.icon = 'info'
      }
      if ( this.data.type === 'wait') {
        this.data.icon = 'info'
      }
      if (!this.data.title) {
          this.data.title = this._defaults.dialog_data.title;
      }
      if (!this.data.title) {
          this.data.title = this._defaults.dialog_data.body;
      }
  }

}
